import React, {Component} from 'react'
import AccountsApi from '../../../api/Corporates/Accounts'
import {message} from 'antd'
import {pick} from 'lodash'
import Accounts from './Accounts'
import {unflatten} from '../../../modules/Utils'

class AccountsCont extends Component {
  state = {
    list: {},
    uniqueList: {},
    filter: '',
  }

  api = new AccountsApi()

  componentDidMount() {
    this.fetch()
  }

  fetch = async () => {
    try {
      this.setState({fetching: true})
      const list = await this.api.list()

      const data = Array.from(list)
      const uniqueTags = []
      const uniqueTemp = []
      data.map(d => {
        if (uniqueTemp.indexOf(d.company._id) === -1) {
          uniqueTemp.push(d.company._id)
          uniqueTags.push(d)
        }
      })

      const unFlattenList = unflatten(list)

      this.setState({
        fetching: false,
        list,
        uniqueList: uniqueTags,
        unFlattenList,
        filtered: unFlattenList,
      })
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
      this.setState({fetching: false})
    }
  }

  onChange = field => {
    if (field) {
      const filtered = this.state.unFlattenList.filter(
        l => l.company._id === field,
      )
      this.setState({filtered, company: field})
    } else this.setState({filtered: this.state.unFlattenList, company: field})
  }

  render() {
    return <Accounts {...this.state} {...pick(this, ['fetch', 'onChange'])} />
  }
}

AccountsCont.propTypes = {}
AccountsCont.defaultProps = {}

export default AccountsCont
